module.exports = __webpack_public_path__ + "files/d981832ed0c50d9c518437c8da4e110d.png";